<script>
import WordCloudView from './WordCloudView.vue'

export default {
  name: 'WordCloudSampleView',
  extends: WordCloudView,
  watch: {
    words() {
      // No-op to disable the inherited watcher from WordCloudView
    },
  },
  methods: {
    /**
     * @override
     * Override the draw method from WordCloudView.
     * This version removes transitions and sets a low opacity for words.
     */
    draw(words) {
      // call super draw method to ensure any necessary setup is done
      WordCloudView.methods.draw.call(this, words)
      // getWordContainer is inherited from WordCloudView
      const wordContainer = this.getWordContainer()

      // remove on click handler
      const selection = wordContainer
        .selectAll('text')
      selection.on('click', null)

      // blur words
      selection.style('opacity', 0.3)
    },
  },
}
</script>

<style lang="scss" scoped>
// Add any component-specific styles here if needed.
// The parent's styles for `.word-cloud-view` and hover effects will be inherited.
</style>
